import { TOOL_OUTPUTS_FOLDER_NAME } from "@app/lib/api/files/mount_path";
import { CONNECTOR_CONFIGURATIONS } from "@app/lib/connector_providers";
import type { ConversationSourceType } from "@app/types/api/assistant/conversation/details";
import { isConnectorProvider } from "@app/types/data_source";
import { asDisplayName } from "@app/types/shared/utils/string_utils";

export type SourceGroup = {
  provider: string;
  label: string;
  sources: ConversationSourceType[];
};

export function getSourceProviderLabel(provider: string): string {
  if (provider === "webcrawler") {
    return "Websites";
  }
  return isConnectorProvider(provider)
    ? CONNECTOR_CONFIGURATIONS[provider].name
    : asDisplayName(provider);
}

export function groupSourcesByProvider(
  sources: ConversationSourceType[]
): SourceGroup[] {
  const groups = new Map<string, SourceGroup>();
  for (const source of sources) {
    const group = groups.get(source.provider);
    if (group) {
      group.sources.push(source);
    } else {
      groups.set(source.provider, {
        provider: source.provider,
        label: getSourceProviderLabel(source.provider),
        sources: [source],
      });
    }
  }
  return [...groups.values()];
}

export function isToolOutputPath(path: string): boolean {
  return path.split("/").includes(TOOL_OUTPUTS_FOLDER_NAME);
}
